import React, { useEffect } from 'react';
import { useState, Downgraded } from '@hookstate/core';
import { Box, Slide } from '@mui/material';
import { generatePath } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import Helper from '../../utility/helper';
import { useEventState } from '../../stores/eventStore';
import { useAuthState } from '../../stores/authStore';
import RouteConstants from '../../constants/routeConstants';
import APIURLConstants from '../../config/config';
import ApiHelper from '../../utility/ApiHelper';
import ConfirmationDialog from '../../sharedcomponents/confirmationdialog/confirmationDialog';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
//import DataList from '../../sharedcomponents/dataList/dataList';
import AccordianCommonRequests from '../../sharedcomponents/commonRequest/accordianCommonRequest';
import {
    NO_ACCESS_PERMISSION,
    FULL_PERMISSION,
    REQUEST_STATUS_LIST
} from '../../constants/Constant';
import UnauthorizedUI from '../../sharedcomponents/emptyStateContainer/unauthorizedUI';
import TransportNote from '../Transportation/transportNote';
import PendingActionDialog from '../../sharedcomponents/confirmationdialog/pendingActionDialog';

import StyledTable1 from '../../sharedcomponents/styledTable/styleTable1';
import CustomDialog from '../../sharedcomponents/dialog/dialog';
import AppConstants from '../../constants/appConstants';

const loader = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
};

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const PrivateVehicle = (props) => {
    const authState = useAuthState();
    const loading = useState(false);
    const eventState = useEventState();
    const eventInfo = Helper.getStorage('eventInfo');
    const transportList = useState(null);
    const selectedEvent = useState(null);
    const setAll = useState(false);
    const userID = useState(null);
    const requestNote = useState(null);
    const allNote = useState(false)
    const [allNoteValue, setAllNoteValue] = React.useState('')
    const openNoteDialog = useState(false);
    const approveLoader = useState(false);
    const rejectLoader = useState(false);
    const [showLoading, setShowLoading] = React.useState(false);
    const pagingInfo = useState({
        currentPage: 1,
        itemsPerPage: 5000,
        noOfPages: null,
    });
    const requestPending = useState(null);
    const pendingAction = useState({
        open: false,
        title: '',
        message: '',
    });
    const [showSearchRec, setShowSearchRec] = React.useState(false);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const approveConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const rejectConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const deleteConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const [modPermission, setModPermission] = React.useState(null);
    const [showStatus, setShowStatus] = React.useState({
        Approved: 0,
        Pending: 0,
        Rejected: 0,
    });
    const approveloading = useState({
        loading: false,
        index: 0
    })
    const rejectloading = useState({
        loading: false,
        index: 0
    })
    const [showHistory, setShowHistory] = React.useState(false);
    const [satNightTransportHistory, setSatNightTransportHistory] =
        React.useState();
    const filteredList = useState([]);
    const allListData = useState([]);
    const allData = useState();
    const fullData = useState([]);
    const [filters, setFilters] = React.useState(null);
    const [filterChangeVal, setFilterChangeVal] = React.useState(false);
    const filteredEmty = useState(false);
    const [participantLists, setParticipantLists] = React.useState(null);
    const displayName = useState(null);

    const statusList = useState(REQUEST_STATUS_LIST);
    const headers = [
        { key: 'useTransport', title: 'Will You Be Using the Private Vehicle Provided by the NBA?' },
        { key: 'VehicleType', title: 'Vehicle Type' },
        { key: 'participant', title: 'Name' },
        { key: 'PriContactName', title: 'Contact Name' },
        { key: 'PriContactNo', title: 'Contact No' },
        { key: 'PriContactEmail', title: 'Contact Email' },
        { key: 'RequestStatus', title: 'Status' },
        { key: 'SpecialRequest', title: 'Special Request' },
        { key: 'IsHotelCheck', title: 'NBA Hotel' },
        { key: 'Location', title: 'Hotel Location' },        
        { key: 'Shared', title: 'Shared' },
        { key: 'AuditBy', title: 'Audit By' },
        { key: 'AuditDate', title: 'Audit Date' },
        { key: 'AuditStatus', title: 'Audit Status' },
    ];

    useEffect(() => {
        const userInfo = Helper.getStorage('userInfo');
        if (eventState && eventState.eventDetail.get()) {
            if (Helper.isAdminUser(userInfo) || Helper.isEventAdmin(userInfo) || Helper.isEventStaff(userInfo)) {
                setModPermission(FULL_PERMISSION);
                userID.set(userInfo.userID);
            } else if (userInfo.roles) {
                const permissions = eventState.permissions
                    .attach(Downgraded)
                    .get();
                userID.set(userInfo.userID);
                if (permissions && permissions.length > 0) {
                    setModPermission(
                        Helper.getModuleAccessPermission(permissions, 'AllSTARPRIVATETRANSPORT')
                    );
                }
            }
        }
        // if (selectedEvent.get() == null || selectedEvent.get()) {
        //     if (eventState && eventState.eventDetail.get()) {
        //         if (
        //             selectedEvent.get() == null ||
        //             eventState.eventDetail.get().eventID !=
        //             selectedEvent.get().eventID
        //         ) {
        //             if (!Helper.isAdminUser(userInfo) && !Helper.isEventAdmin(userInfo)) {
        //                 const permissions = eventState.permissions
        //                     .attach(Downgraded)
        //                     .get();
        //                 if (permissions && permissions.length > 0) {
        //                     setModPermission(
        //                         Helper.getModuleAccessPermission(
        //                             permissions,
        //                             'AllSTARPRIVATETRANSPORT'
        //                         )
        //                     );
        //                 }
        //             } else if (Helper.isAdminUser(userInfo) || Helper.isEventAdmin(userInfo)) {
        //                 setModPermission(FULL_PERMISSION);
        //             }
        //             selectedEvent.set(
        //                 eventState.eventDetail.attach(Downgraded).get()
        //             );
        //         } else {
        //             if (Helper.isAdminUser(userInfo) || Helper.isEventStaff(userInfo)) {
        //                 setModPermission(FULL_PERMISSION);
        //             }
        //         }
        //     }
        //     // else {
        //     //     const eventInfo = Helper.getStorage('eventInfo');
        //     //     if (
        //     //         selectedEvent.get() == null ||
        //     //         selectedEvent.get().eventID != selectedEvent.get().eventID
        //     //     ) {
        //     //         selectedEvent.set(eventInfo);
        //     //     }
        //     // }
        // }
    }, [eventState]);
    const getParticipantList = () => {
        const gUserInfo = Helper.getStorage('userInfo');
        const gEventInfo = Helper.getStorage('eventInfo');
        if (
            Helper.isAdminUser(gUserInfo) ||
            (gUserInfo.roles && Helper.isEventAdmin(gUserInfo)) || (gUserInfo.roles && Helper.isEventStaff(gUserInfo))
        ) {
            ApiHelper.get(
                APIURLConstants.GET_ADMIN_EVENT_PARTICIPANTS(gEventInfo.eventID)
            ).then((res) => {
                if (res.data.rows) {
                    const participants = res.data.rows.filter(
                        (participant) =>
                            AppConstants.EVENT_ROLES_VALUES.indexOf(
                                participant.roleName
                            ) == -1
                    );
                    setParticipantLists(participants);
                }
            });
        }
    };
    useEffect(() => {
        const fetch = async () => {
            const userInfo = Helper.getStorage('userInfo');
            const eventInfo = Helper.getStorage('eventInfo');

            eventInfo.moduleDetails.filter((x) => x.moduleID === AppConstants.EVENT_MODULES.PRIVATE_TRANSPORT).map((item) => {
                displayName.set(item.displayName)
            })
            userID.set(userInfo.userID);
            const authStateInfo = authState
                .nested('appDetails')
                .attach(Downgraded)
                .get();
            if (
                authState &&
                authStateInfo &&
                authStateInfo.itemsPerPage &&
                pagingInfo.get().itemsPerPage == null &&
                modPermission &&
                modPermission != NO_ACCESS_PERMISSION
            ) {
                pagingInfo.set({
                    ...pagingInfo,
                    currentPage: 1,
                    itemsPerPage: authStateInfo.itemsPerPage,
                    noOfPages: null,
                });
                const eventDetail = selectedEvent.attach(Downgraded).get();
                if (eventDetail && eventDetail.eventID) {
                    console.log('modPermission : ', modPermission);
                    //getTransportRequests();
                }
            }
        };
        fetch();
    }, [authState, modPermission]);

    useEffect(() => {
        if (modPermission && modPermission != NO_ACCESS_PERMISSION) {
            const pageInfo = pagingInfo.attach(Downgraded).get();
            if (pageInfo.itemsPerPage) {
                getTransportList();
            }
            getParticipantList();
        }
    }, [modPermission]);

    const onPendingAction = (item, index) => {
        if (item.actualData.requestStatus == 'Approved') {
            approveloading.set({
                loading: true,
                index: index
            })
        }
        else if (item.actualData.requestStatus == 'Rejected') {
            rejectloading.set({
                loading: true,
                index: index
            })
        }
        let newData = [...transportList.attach(Downgraded).get()];
        let Index = newData.findIndex(
            (data) => data.actualData.priTransportID == item.actualData.priTransportID
        );
        let newItem = newData[Index].actualData;

        const isStatus = 1;

        requestPending.set({
            priTransportID: newItem.priTransportID,
            status: isStatus,
            userID: userID.get(),
            item: newItem,
            index,
        });

        let message = 'Do you want to move request to pending?';

        pendingAction.set({
            open: true,
            title: '',
            OkButtonText: 'Ok',
            message: message,
        });
    };

    const handlePendingAction = async () => {
        pendingAction.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
        const newRequestNote = requestPending.attach(Downgraded).get();
        const statusReq = {
            priTransportID: newRequestNote.priTransportID,
            Shared: -1,
            Status: newRequestNote.status,
            ModifiedBy: newRequestNote.userID,
            isMail: 1
        };
        ApiHelper.post(
            APIURLConstants.PRIVATE_TRANSPORT_UPDATE_STATUS,
            statusReq
        ).then(async (res) => {
            if (res.data) {
                rejectloading.set({
                    loading: false,
                    index: 0
                })
                approveloading.set({
                    loading: false,
                    index: 0
                })
                pendingAction.set({
                    open: false,
                    title: '',
                    OkButtonText: 'Ok',
                    message: '',
                });
                requestPending.set(null);
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'success',
                    message: 'Request updated successfully',
                });
                // await getEmailNotification(newRequestNote);
                await getTransportList();
            }
        });
    };
    const handlePageChange = (event, page) => {
        pagingInfo.set({
            ...pagingInfo,
            currentPage: page,
            itemsPerPage: pagingInfo.get().itemsPerPage,
            noOfPages: pagingInfo.get().noOfPages,
        });
        getTransportList();
    };
    const onToggleChange = (event, findIndex, item) => {
        let newData = fullData.attach(Downgraded).get();
        let index = newData.findIndex(
            (data) => data.actualData.priTransportID == item.actualData.priTransportID
        );
        let newItem = newData[index];
        newItem.actualData.sharedWithVendor = event.target.checked;
        const shareIndex = newItem.row.findIndex(
            (rw) => rw.key == 'sharedWithVendor'
        );

        newItem.row[shareIndex].sharedWithVendor = event.target.checked;
        transportList[index].set(newItem);
        const isChecked = event.target.checked ? 1 : 0;

        onSharedVendor(isChecked, item.actualData.priTransportID, userID.get());
    };
    const onSharedVendor = (isChecked, transportID, userID) => {
        const updateShared = {
            priTransportID: transportID,
            shared: isChecked,
            status: -1,
            modifiedBy: userID,
            isMail: 0
        };
        ApiHelper.post(
            APIURLConstants.PRIVATE_TRANSPORT_UPDATE_STATUS,
            updateShared
        )
            .then(async (res) => {
                if (res.data) {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request updated successfully',
                    });
                    loading.set(false);
                }
            })
            .catch((error) => {
                loading.set(false);
                if (error.response && error.response.status === 401) {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: 'Access denied',
                    });
                } else {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: 'Error while creating request',
                    });
                }
            });
    };

    const onActionClick = (item, index, action) => {
        if (action == 'Approve') {
            approveloading.set({
                loading: true,
                index: index
            })
        }
        else if (action == 'Reject') {
            rejectloading.set({
                loading: true,
                index: index
            })
        }
        let newData = [...fullData.attach(Downgraded).get()];
        let Index = newData.findIndex(
            (data) => data.actualData.priTransportID == item.actualData.priTransportID
        );
        let newItem = newData[Index].actualData;

        const isStatus = action == 'Approve' ? 2 : action == 'Reject' ? 3 : 1;
        requestNote.set({
            priTransportID: newItem.priTransportID,
            status: isStatus,
            userID: userID.get(),
            addedBy: userID.get(),
            action,
            item: newItem,
            index,
            note: newItem.note,
        });
        openNoteDialog.set(true);
    };

    const closeNoteDialog = () => {
        approveloading.set({
            loading: false,
            index: 0
        })
        rejectloading.set({
            loading: false,
            index: 0
        })
        openNoteDialog.set(false);
        requestNote.set(null);
    };
    const saveAppNotification = (obj) => {
        let payLoad = {
            appNotificationID: 0,
            userIDs: JSON.stringify(obj.item.addedFor),
            appNotificationTypeID: 1,
            eventID: eventInfo.eventID,
            moduleID: 23,
            recordRefID: obj.priTransportID,
            requestStatus: obj.status,
            status: 0,
            createdBy: userID.get(),
        };
        ApiHelper.post(APIURLConstants.SAVE_APP_NOTIFICATION, payLoad).then(res => {
            console.log(res);
            ApiHelper.get(
                APIURLConstants.GET_MOBILE_PUSH_NOTIFICATION(
                    obj.item.addedFor,
                    eventInfo.eventID,
                    eventInfo.eventName,
                    displayName.get(),
                    obj.status === 2 ? "Approved" : obj.status === 3 ? "Rejected" : "Pending"
                )
            ).then((res) => {
                console.log(res);
            });
        }).catch(err => {
            console.log(err);
        })
    }
    // const getEmailNotification = async (ObjRequest) =>
    // {
    //     return ApiHelper.post(
    //         APIURLConstants.POST_SET_SAT_NIGHT_EMAIL_NOTIFICATION,
    //         ObjRequest.item
    //     )
    //         .then((result) =>
    //         {
    //             return result.data;
    //         })
    //         .catch((err) =>
    //         {
    //             console.log(err);
    //         });
    // };
    const updateNote = async (value) => {
        setShowLoading(true);
        let newRequestNote = { ...requestNote.attach(Downgraded).get() };
        newRequestNote['note'] = value;
        newRequestNote['item'].note = value
        const statusUpdate = ApiHelper.post(
            APIURLConstants.PRIVATE_TRANSPORT_UPDATE_STATUS,
            {
                priTransportID: newRequestNote.priTransportID,
                Shared: -1,
                Status: newRequestNote.status,
                ModifiedBy: newRequestNote.userID,
                isMail: 0
            }
        );
        const req = {
            priTransportID: newRequestNote.priTransportID,
            note: newRequestNote.note,
            addedBy: newRequestNote.userID,
        };
        const noteUpdate = ApiHelper.post(
            APIURLConstants.PRIVATE_TRANSPORT_UPDATE_NOTE,
            req
        );

        await Promise.all([statusUpdate, noteUpdate]).then(async (data) => {
            const [first, second] = data;
            if (first && second) {
                setShowLoading(false);
                approveloading.set({
                    loading: false,
                    index: 0
                })
                rejectloading.set({
                    loading: false,
                    index: 0
                })
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'success',
                    message: 'Status updated successfully',
                });
                // getEmailNotification(newRequestNote);
                getTransportList();
                if (eventInfo.readonlyOrHide === 0) {
                    saveAppNotification(newRequestNote);
                }
                closeNoteDialog();
            }
        });
    };
    const hanldeAllNoteValue = (item) => {
        setAllNoteValue(item)
    }
    const getTransportList = () => {
        loading.set(true);
        let participantList = [];
        const gEventInfo = Helper.getStorage('eventInfo');
        ApiHelper.get(
            APIURLConstants.GET_PRIVATE_TRANSPORT_LIST(
                gEventInfo.eventID
            )
        )
            .then((res) => {
                if (res.data.rows) {
                    let data = res.data.rows;
                    let requestData = [];
                    let allrequestData = [];
                    if (data.length > 0) {
                        let approved = 0;
                        let pending = 0;
                        let rejected = 0;
                        data.map((item) => {
                            if (item.requestStatus === 'Approved') {
                                approved += 1;
                            } else if (item.requestStatus === 'Pending') {
                                pending += 1;
                            } else {
                                rejected += 1;
                            }
                            if (
                                participantList.indexOf(item.participant) == -1
                            ) {
                                participantList.push(item.participant);
                            }
                            allrequestData.push({
                                actualData: item,
                                row: [
                                    {
                                        label: 'checkbox',
                                        key: 'transportID',
                                        transportID: item.transportID,
                                        width: '0.05',
                                    },
                                    {
                                        label: 'Participant',
                                        key: 'participant',
                                        participant: item.participant,
                                        width: '0.25',
                                        showLabel: false,
                                        addLink: false,
                                        toEmail: item.email,
                                        showEmail: true,
                                        // alignCenter: true,
                                        showEventType: true,
                                    },
                                    {
                                        label: 'Submitted By',
                                        key: 'submittedBy',
                                        submittedBy: item.submittedBy,
                                        width: '0.20',
                                        inColumn: true,
                                        // alignCenter: true,
                                    },
                                    {
                                        label: 'Submitted Date',
                                        key: 'submittedDate',
                                        submittedDate: Helper.FormatDate(
                                            item.submittedDate
                                        ),
                                        width: '0.15',
                                        inColumn: true,
                                    },
                                    {
                                        label: 'History',
                                        key: 'auditHistory',
                                        auditHistory: '',
                                        width: '0.10',
                                        showLabel: false,
                                        showChips: false,
                                        inColumn: true,
                                        // alignCenter: true,
                                    },
                                    {
                                        label: 'Shared',
                                        key: 'sharedWithVendor',
                                        sharedWithVendor: item.shared,
                                        width: '0.10',
                                        showSwitch: true,
                                        inColumn: true,
                                        alignCenter: true,
                                    },
                                    {
                                        label: 'Status',
                                        key: 'requestStatus',
                                        requestStatus: item.requestStatus,
                                        width: '0.05',
                                        showStatusIcon: true,
                                        inColumn: true,
                                        alignCenter: true,
                                    },
                                    {
                                        label: 'Action',
                                        key: 'All',
                                        all: 'All',
                                        width: '0.10',
                                    },
                                ],
                                selected: false,
                            });
                        });
                        fullData.set(allrequestData)

                        setShowStatus({
                            Approved: approved,
                            Pending: pending,
                            Rejected: rejected,
                        });

                    } else {
                        setShowStatus({ Approved: 0, Pending: 0, Rejected: 0 });
                        fullData.set([])
                    }
                    transportList.set(allrequestData);
                    let filterData = filteredList.attach(Downgraded).get();
                    if (filterData.length > 0) {
                        setFilterChangeVal(false);
                    }
                    allData.set(requestData);
                    allListData.set(requestData);
                    setFilters({
                        participant: participantList,
                        requestStatus: statusList.attach(Downgraded).get(),
                    });
                    {
                        pagingInfo.set({
                            ...pagingInfo,
                            currentPage: pagingInfo.get().currentPage,
                            itemsPerPage: pagingInfo.get().itemsPerPage,
                            noOfPages: Math.ceil(
                                data.length /
                                pagingInfo.get().itemsPerPage
                            ),
                        });
                    }
                }
                loading.set(false);
            })
            .catch((error) => {
                loading.set(false);
                if (error.response && error.response.status === 401) {
                    alert(error);
                }
            });
    };
    const redirectToTransit = (row) => {
        const path = generatePath(
            RouteConstants.PRIVATE_VEHICLE_EDIT,
            {
                eventID: row.actualData.eventID,
                priTransportID: row.actualData.priTransportID,
            }
        );

        props.history.push({
            pathname: path,
            state: {
                privateVehicleState: row.actualData,
            },
        });
    };

    const handleClick = () => {
        let registeredIds = fullData
            .attach(Downgraded)
            .get()
            .map((x) => x.actualData.addedFor);
        let filteredParticipants = participantLists.filter(
            (x) => !registeredIds.includes(x.userID)
        );
        const gEventInfo = Helper.getStorage('eventInfo');

        props.history.push({
            pathname: generatePath(
                RouteConstants.PRIVATE_VEHICLE_CREATE,
                {
                    eventID: gEventInfo.eventID,
                }
            ),
            state: { participantList: filteredParticipants },
        });
    };

    const deleteRows = () => {
        // const selected = transportList
        // .attach(Downgraded)
        // .get()
        // .filter((user) => user.selected === true);
        const selected1 = fullData
            .attach(Downgraded)
            .get()
            .filter((user) => user.selected === true);
        if (selected1.length === 0) {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select request first',
            });
        } else {
            let message = setAll.get()
                ? 'Do you want to delete all request?'
                : 'Do you want to delete selected request?';

            deleteConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    };

    const handleConfirmation = () => {
        let deleteRequests = [];
        // transportList.get().map((row) =>
        // {
        //     if (row.selected === true)
        //     {
        //         deleteRequests.push(row.actualData.transportID);
        //     }
        // });
        fullData.get().map((row) => {
            if (row.selected === true) {
                deleteRequests.push(row.actualData.priTransportID);
            }
        });
        ApiHelper.post(APIURLConstants.DELETE_PRIVATE_TRANSPORT, {
            Ids: deleteRequests.join(','),
            softDelete: true,
            cancel: true,
            ModifiedBy: userID.value,
        })
            .then((res) => {
                if (res.data) {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request deleted successfully',
                    });
                    // onDelete(false);
                    setAll.set(false);
                    getTransportList();
                }
            })
            .catch((error) => {
                let message = '';
                if (error.response && error.response.status === 401) {
                    message = 'Access denied';
                } else {
                    message = 'Error while deleting request';
                }
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            });
        deleteConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };

    const getSatNightHistory = (id) => {
        ApiHelper.get(APIURLConstants.GET_PRIVATE_TRANSPORT_HISTORY(id)).then(
            (res) => {
                let arr = [];
                res.data.map((item, index, originalArr) => {
                    console.log(item, index, originalArr);
                    let txt = [];
                    let preTxt = [];
                    let previous = originalArr[index - 1];
                    if (
                        item.eventForm &&
                        item.eventForm !== null &&
                        item.eventForm !== ''
                    ) {
                        item.eventForm = JSON.parse(item.eventForm);
                        item.eventForm?.FormFields?.forEach((item) => {
                            if (item.find((x) => x.FieldValue)) {
                                txt.push(
                                    item.find((x) => x.FieldValue)?.FieldName
                                );
                            }
                        });
                    }
                    if (
                        previous?.eventForm &&
                        previous?.eventForm !== null &&
                        previous?.eventForm !== ''
                    ) {
                        let form = previous?.eventForm;
                        form?.FormFields?.forEach((itm) => {
                            if (itm.find((x) => x.FieldValue)) {
                                preTxt.push(
                                    itm.find((x) => x.FieldValue)?.FieldName
                                );
                            }
                        });
                    }
                    arr.push({
                        actualData: item,
                        row: [
                            {
                                useTransport: item.isSelected
                                    ? 'Yes'
                                    : 'No',
                                highlight:
                                    index > 0
                                        ? previous?.isSelected !==
                                            item.isSelected
                                            ? true
                                            : false
                                        : false,
                            },
                            {
                                VehicleType: item.vehicleType && item.vehicleType === "2" ? "SUV" :
                                    item.vehicleType && item.vehicleType === "1" ? "Sprinter (8-12 Pax)" : '',
                                highlight:
                                    index > 0
                                        ? previous?.vehicleType !==
                                            item.vehicleType
                                            ? true
                                            : false
                                        : false,
                            },
                            {
                                participant: item.participant,
                                highlight:
                                    index > 0
                                        ? previous?.participant !==
                                            item.participant
                                            ? true
                                            : false
                                        : false,
                            },

                            {
                                PriContactName: item.contactName,
                                highlight:
                                    index > 0
                                        ? previous?.contactName !==
                                            item.contactName
                                            ? true
                                            : false
                                        : false,
                            },
                            {
                                PriContactNo: item.contactPhone,
                                highlight:
                                    index > 0
                                        ? previous?.contactPhone !==
                                            item.contactPhone
                                            ? true
                                            : false
                                        : false,
                            },
                            {
                                PriContactEmail: item.contactEmail,
                                highlight:
                                    index > 0
                                        ? previous?.contactEmail !==
                                            item.contactEmail
                                            ? true
                                            : false
                                        : false,
                            },
                            {
                                RequestStatus: item.requestStatus,
                                highlight:
                                    index > 0
                                        ? previous?.requestStatus !==
                                            item.requestStatus
                                            ? true
                                            : false
                                        : false,
                            },
                            {
                                SpecialRequest: item.specialRequest,
                                highlight:
                                    index > 0
                                        ? previous?.specialRequest !==
                                            item.specialRequest
                                            ? true
                                            : false
                                        : false,
                            },
                            {
                                IsHotelCheck: item.isHotelCheck === true ? "Yes" : "No",
                                highlight:
                                    index > 0
                                        ? previous?.isHotelCheck !==
                                            item.isHotelCheck
                                            ? true
                                            : false
                                        : false,
                            },
                            {
                                Location: item.location,
                                highlight:
                                    index > 0
                                        ? previous?.location !==
                                            item.location
                                            ? true
                                            : false
                                        : false,
                            },
                            {
                                Shared: item.shared
                                    ? 'Yes'
                                    : 'No',
                                highlight:
                                    index > 0
                                        ? previous?.shared !==
                                            item.shared
                                            ? true
                                            : false
                                        : false,
                            },
                            {
                                AuditBy: item.auditBy,
                                highlight:
                                    index > 0
                                        ? previous?.auditBy !==
                                            item.auditBy
                                            ? true
                                            : false
                                        : false,
                            },
                            {
                                AuditDate: Helper.FormatDateTime(item.auditDate),
                                highlight:
                                    index > 0
                                        ? previous?.auditDate !==
                                            item.auditDate
                                            ? true
                                            : false
                                        : false,
                            },
                            {
                                AuditStatus: item.auditStatus,
                                highlight:
                                    index > 0
                                        ? previous?.auditStatus !==
                                            item.auditStatus
                                            ? true
                                            : false
                                        : false,
                            },

                        ],
                    });
                });
                setSatNightTransportHistory(arr);
            }
        );
    };
    const showSatNightHistory = (item) => {
        setShowHistory(true);
        getSatNightHistory(item.actualData.priTransportID);
    };

    const renderDialogContent = () => {
        let finalHeaders = [...headers];
        let finalDataHistory =
            satNightTransportHistory &&
            JSON.parse(JSON.stringify(satNightTransportHistory));
        // let event = eventState.attach(Downgraded).get()
        return (
            <StyledTable1 rowHeader={finalHeaders} data={finalDataHistory} />
        );
    };

    const renderDialogActions = () => { };

    const generateExcelReport = async (result) => {
        let selectedIds = [];
        let IDs = null;
        if (result.length > 0) {
            result.map((item) => {
                selectedIds.push(item.actualData.priTransportID);
            });
            IDs = selectedIds.join(',');
        }
        const gEventInfo = Helper.getStorage('eventInfo');
        await ApiHelper.post(
            APIURLConstants.Excel_Export, { EventID: gEventInfo.eventID, ModuleID: 23, IDs: IDs }
        ).then((res) => {
            const finalObject = JSON.parse(res.data.value);
            if (finalObject) {
                if (finalObject.length > 0) {
                    let header = {};
                    Object.keys(finalObject[0]).map((key) => {
                        header[key] = key;
                    });

                    finalObject.unshift(header);

                    Helper.downloadReport(
                        finalObject,
                        `AllStarPrivateTransport-Report`
                    );
                }
            }
        });
    };

    const callExport = () => {
        console.log("fullData", fullData
            .attach(Downgraded)
            .get(), "filteredList", filteredList
                .attach(Downgraded)
                .get());
        if (filteredList.attach(Downgraded).length !== 0) {
            const selected = filteredList
                .attach(Downgraded)
                .get()
                .filter((user) => user.selected === true);

            const allSelected = filteredList
                .attach(Downgraded)
                .get()
                .filter((user) => user.selected === false);

            if (selected.length === 0) {
                generateExcelReport(allSelected);
            } else {
                generateExcelReport(selected);
            }
        } else {
            const selected = fullData
                .attach(Downgraded)
                .get()
                .filter((user) => user.selected === true);

            const allSelected = fullData
                .attach(Downgraded)
                .get()
                .filter((user) => user.selected === false);

            if (selected.length === 0) {
                generateExcelReport(allSelected);
            } else {
                generateExcelReport(selected);
            }
        }
    };
    const filterListData = (data) => {
        if (data.length == 0) {
            filteredEmty.set(true);
        } else {
            filteredEmty.set(false);
        }
        filteredList.set(data);
    };
    const multiApprove = () => {
        // const selected = allData
        //     .attach(Downgraded)
        //     .get()
        //     .filter((user) => user.selected === true);
        const selected1 = fullData
            .attach(Downgraded)
            .get()
            .filter((user) => user.selected === true);
        if (selected1.length === 0) {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select request first',
            });
        } else {
            let message = setAll.get()
                ? 'Do you want to Approve all request?'
                : 'Do you want to Approve selected request?';
            allNote.set(true)
            approveConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    };
    const multiReject = () => {
        const selected = allData
            .attach(Downgraded)
            .get()
            .filter((user) => user.selected === true);
        const selected1 = fullData
            .attach(Downgraded)
            .get()
            .filter((user) => user.selected === true);
        if (selected.length === 0 && selected1.length === 0) {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select request first',
            });
        } else {
            let message = setAll.get()
                ? 'Do you want to Reject all request?'
                : 'Do you want to Reject selected request?';
            allNote.set(true)
            rejectConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    };
    const getMultiEmailNotification = async (multiUsers, requestIds) => {
        multiUsers.map((user, index) => {
            let form = new FormData();
            form.append('UserID', user);
            form.append('EventID', eventInfo.eventID)
            form.append('TemplateType', 'AllStarPrivateTransport')
            form.append('ID', requestIds[index])
            form.append('ModifyBy', userID.value)
            form.append('TranportType', 'AllStarPrivateTransport')
            form.append('ModuleID', 23)
            return ApiHelper.post(
                APIURLConstants.POST_EMAIL_NOTIFICATION,
                form
            )
                .then((result) => {
                    return result.data;
                })
                .catch((err) => {
                    console.log(err);
                });
        })
    }
    const multisaveAppNotification = (multiUsers, requestIds, status) => {
        const gEventInfo = Helper.getStorage('eventInfo');

        multiUsers.map((user, index) => {
            let payLoad = {
                appNotificationID: 0,
                userIDs: JSON.stringify(user),
                appNotificationTypeID: 1,
                eventID: gEventInfo.eventID,
                moduleID: 23,
                recordRefID: requestIds[index],
                requestStatus: status,
                status: 0,
                createdBy: userID.get(),
            };
            ApiHelper.post(APIURLConstants.SAVE_APP_NOTIFICATION, payLoad).then(res => {
                console.log(res);
                ApiHelper.get(
                    APIURLConstants.GET_MOBILE_PUSH_NOTIFICATION(
                        user,
                        gEventInfo.eventID,
                        gEventInfo.eventName,
                        "AllStarPrivateTransport",
                        status === 2 ? "Approved" : status === 3 ? "Rejected" : "Pending"
                    )
                ).then((res) => {
                    console.log(res);
                });
            }).catch(err => {
                console.log(err);
            })
        })
    }
    const handleRejectConfirmation = () => {
        const gEventInfo = Helper.getStorage('eventInfo');
        const gUserInfo = Helper.getStorage('userInfo');
        let rejectRequests = [];
        let multiUsers = [];
        allData.get().map((row) => {
            if (row.selected === true) {
                rejectRequests.push({
                    userID: row.actualData.addedFor,
                    iD: row.actualData.priTransportID,
                    transportType: 'AllStarPrivateTransport'
                });
                multiUsers.push(row.actualData.addedFor);
            }
        });
        fullData.get().map((row) => {
            if (row.selected === true) {
                rejectRequests.push({
                    userID: row.actualData.addedFor,
                    iD: row.actualData.priTransportID,
                    transportType: 'AllStarPrivateTransport'
                });
                multiUsers.push(row.actualData.addedFor);
            }
        });
        rejectLoader.set(true);
        ApiHelper.post(APIURLConstants.UPDATE_MULTI_SELECT_STATUS, {
            Ids: JSON.stringify(rejectRequests),
            Status: 3,
            Note: allNoteValue,
            EventID: gEventInfo.eventID,
            ModuleID: 23,
            ModifiedBy: gUserInfo.userID,
            TemplateType: "AllStarPrivateTransport",
            TransportType: "AllStarPrivateTransport",
            appNotificationTypeID: 1,
        })
            .then((res) => {
                if (res.data) {
                    rejectLoader.set(false);
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request rejected successfully',
                    });
                    setAll.set(false);
                    getTransportList();
                    // getMultiEmailNotification(multiUsers, rejectRequests);
                    // if (eventInfo.readonlyOrHide === 0)
                    // {
                    //     multisaveAppNotification(multiUsers, rejectRequests, 3);
                    // }
                }
            })
            .catch((error) => {
                rejectLoader.set(false);
                console.log(error)
                let message = '';
                if (error.response && error.response.status === 401) {
                    message = 'Access denied';
                } else {
                    message = 'Error while reject request';
                }
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            });
        rejectConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };
    const handleApproveConfirmation = () => {
        const gEventInfo = Helper.getStorage('eventInfo');
        const gUserInfo = Helper.getStorage('userInfo');
        let approveRequests = [];
        let multiUsers = [];
        allData.get().map((row) => {
            if (row.selected === true) {
                approveRequests.push({
                    userID: row.actualData.addedFor,
                    iD: row.actualData.priTransportID,
                    transportType: 'AllStarPrivateTransport'
                });
                multiUsers.push(row.actualData.addedFor);

            }
        });
        fullData.get().map((row) => {
            if (row.selected === true) {
                approveRequests.push({
                    userID: row.actualData.addedFor,
                    iD: row.actualData.priTransportID,
                    transportType: 'AllStarPrivateTransport'
                });
                multiUsers.push(row.actualData.addedFor);

            }
        });
        approveLoader.set(true);
        ApiHelper.post(APIURLConstants.UPDATE_MULTI_SELECT_STATUS, {
            Ids: JSON.stringify(approveRequests),
            Status: 2,
            Note: allNoteValue,
            EventID: gEventInfo.eventID,
            ModuleID: 23,
            ModifiedBy: gUserInfo.userID,
            TemplateType: "AllStarPrivateTransport",
            TransportType: "AllStarPrivateTransport",
            appNotificationTypeID: 1,
        })
            .then((res) => {
                console.log('res', res);
                if (res.data) {
                    approveLoader.set(false);
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request approved successfully',
                    });
                    setAll.set(false);
                    getTransportList();
                    // getMultiEmailNotification(multiUsers, approveRequests)
                    // if (eventInfo.readonlyOrHide === 0)
                    // {
                    //     multisaveAppNotification(multiUsers, approveRequests, 2);
                    // }
                }
            })
            .catch((error) => {
                approveLoader.set(false);
                let message = '';
                if (error.response && error.response.status === 401) {
                    message = 'Access denied';
                } else {
                    message = 'Error while approve request';
                }
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            });
        approveConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };
    // console.log("loading.get()",loading.get(),modPermission, fullData.get());
    
    return (
        <Box sx={{
            width: '100%',
            overflow: 'auto',
            maxHeight: 'calc(100vh - 70px)',
        }}>
            {loading.get() ? (
                <Box style={loader}>
                    <CircularProgress />
                </Box>
            ) : modPermission && modPermission == NO_ACCESS_PERMISSION ? (
                <UnauthorizedUI showLogout={false} />
            ) : fullData.get() ? (
                <AccordianCommonRequests
                    // new props
                    data={fullData.attach(Downgraded).get()}
                    allData={fullData.attach(Downgraded).get()}
                    editRow={redirectToTransit}
                    handleClick={handleClick}
                    title={''}
                    loading={loading.get()}
                    buttonTitle={'Add'}
                    deleteRows={deleteRows}
                    filterChangeVal={filterChangeVal}
                    showSearch={true}
                    searchLabel={'Search'}
                    showSearchRec={showSearchRec}
                    setShowSearchRec={setShowSearchRec}
                    onSwitchToggle={onToggleChange}
                    onActionClick={onActionClick}
                    showSync={true}
                    showExport={true}
                    showHistory={showSatNightHistory}
                    // showSettings={true}
                    callExport={callExport}
                    getResults={getTransportList}
                    // pagingInfo={pagingInfo.attach(Downgraded).get()}
                    // handlePageChange={handlePageChange}
                    snackBarProps={snackBarProps}
                    setSnackBarProps={setSnackBarProps}
                    onPendingAction={onPendingAction}
                    modPermission={modPermission}
                    filterListData={filterListData}
                    moduleToShow={'Private Transport'}
                    moduleDisplayName={
                        Helper.getModuleName(eventInfo ? eventInfo.moduleDetails : [],
                            AppConstants.EVENT_MODULES.PRIVATE_TRANSPORT)
                    }
                    showRequestStatus={showStatus}
                    showApproveAndReject={true}
                    multiApprove={multiApprove}
                    multiReject={multiReject}
                    approveLoader={approveLoader.get()}
                    rejectLoader={rejectLoader.get()}
                    approveloading={approveloading.get()}
                    rejectloading={rejectloading.get()}
                    showFilter={true}
                    filters={filters}
                // titleHeader='SatNightTransport'
                />
            ) : null}

            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({
                            ...snackBarProps,
                            openSnack: false,
                        })
                    }></CustomizedSnackbars>
            )}
            {
                <ConfirmationDialog
                    open={deleteConfirmation.get().open}
                    message={deleteConfirmation.get().message}
                    OkButtonText={deleteConfirmation.get().OkButtonText}
                    handleCnfClick={() =>
                        handleConfirmation(deleteConfirmation)
                    }
                    onCancelClick={() => {
                        deleteConfirmation.set({
                            ...deleteConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
            {openNoteDialog.get() && (
                <TransportNote
                    showLoading={showLoading}
                    loading={showLoading}
                    open={openNoteDialog.get()}
                    title={`${requestNote.get().action} Note`}
                    handleClose={closeNoteDialog}
                    updateNote={updateNote}
                    data={requestNote.attach(Downgraded).get()}
                />
            )}
            {
                <PendingActionDialog
                    open={pendingAction.get().open}
                    message={pendingAction.get().message}
                    OkButtonText={pendingAction.get().OkButtonText}
                    handleCnfClick={() => handlePendingAction(pendingAction)}
                    onCancelClick={() => {
                        pendingAction.set({
                            ...pendingAction.get(),
                            open: false,
                        });
                        approveloading.set({
                            loading: false,
                            index: 0
                        })
                        rejectloading.set({
                            loading: false,
                            index: 0
                        })
                    }}></PendingActionDialog>
            }
            {showHistory && (
                <CustomDialog
                    TransitionComponent={Transition}
                    title={'Private Transport History'}
                    maxWidth="xl"
                    showClose={true}
                    open={showHistory}
                    handleClose={() => {
                        setShowHistory(false);
                    }}
                    fullWidth={true}
                    renderContent={renderDialogContent}
                    renderActions={renderDialogActions}
                />
            )}
            {
                <ConfirmationDialog
                    open={rejectConfirmation.get().open}
                    message={rejectConfirmation.get().message}
                    OkButtonText={rejectConfirmation.get().OkButtonText}
                    note={allNote}
                    allNoteValue={hanldeAllNoteValue}
                    handleCnfClick={() =>
                        handleRejectConfirmation(rejectConfirmation)
                    }
                    onCancelClick={() => {
                        rejectConfirmation.set({
                            ...rejectConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
            {
                <ConfirmationDialog
                    open={approveConfirmation.get().open}
                    message={approveConfirmation.get().message}
                    OkButtonText={approveConfirmation.get().OkButtonText}
                    note={allNote}
                    allNoteValue={hanldeAllNoteValue}
                    handleCnfClick={() =>
                        handleApproveConfirmation(approveConfirmation)
                    }
                    onCancelClick={() => {
                        approveConfirmation.set({
                            ...approveConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
        </Box>
    );
};

export default {
    routeProps: {
        path: RouteConstants.PRIVATE_VEHICLE_ADMIN_LIST,
        component: PrivateVehicle,
    },
    name: 'PrivateVehicle',
};
